import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { ConfirmationModal, TextField } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useLegalTerms } from '../../../hooks/reactQuery/queries/useLegalTerms';
const MAX_NAME_LENGTH = 80;
export var NameThisDocumentModalError = /*#__PURE__*/ function(NameThisDocumentModalError) {
    NameThisDocumentModalError["LEGAL_TERMS_NAME_ALREADY_EXISTS"] = "LEGAL_TERMS_NAME_ALREADY_EXISTS";
    return NameThisDocumentModalError;
}({});
export const { NameThisDocumentModalTID } = getTestIds();
export const NameThisDocumentModal = (props)=>{
    const { t: texts } = useLocaleKeys('components.legalTermsDropdown');
    const { t: commonTexts } = useLocaleKeys('common');
    const { currentFileName, onConfirm, dismissModal, currentLegalTermsId } = props;
    const { legalTerms } = useLegalTerms();
    const [name, setName] = useState(()=>currentFileName);
    const [error, setError] = useState(undefined);
    const [isSaving, setIsSaving] = useState(false);
    const existingNames = useMemo(()=>new Set(legalTerms.filter((term)=>term.id !== currentLegalTermsId).map((term)=>term.name.toLowerCase())), [
        legalTerms,
        currentLegalTermsId
    ]);
    const isDuplicateName = existingNames.has(name.trim().toLowerCase());
    const isNameTooLong = name.length > MAX_NAME_LENGTH;
    const hasError = !!error || isDuplicateName || isNameTooLong;
    const helperText = useMemo(()=>{
        if (isDuplicateName || error === "LEGAL_TERMS_NAME_ALREADY_EXISTS") {
            return texts.duplicateNameError();
        } else if (isNameTooLong) {
            return texts.nameTooLongError();
        }
        return texts.documentNameHelperText();
    }, [
        error,
        isDuplicateName,
        isNameTooLong
    ]);
    const handleSave = async ()=>{
        if (!hasError && name.trim()) {
            setIsSaving(true);
            const result = await onConfirm(name.trim());
            if (result.success === true) {
                dismissModal(result.data);
            } else if (NameThisDocumentModalError[result.error]) {
                setError(result.error);
            }
            setIsSaving(false);
        }
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'name_this_document_confirm'
            },
            secondaryButton: {
                name: 'name_this_document_cancel'
            }
        },
        title: currentLegalTermsId ? texts.renameDocument() : texts.nameDocumentTitle(),
        testId: NameThisDocumentModalTID.NameThisDocumentModal(),
        textAlignCenter: false,
        content: /*#__PURE__*/ _jsx(TextField, {
            bi: {
                name: 'document_name'
            },
            collapseHelperText: true,
            testId: NameThisDocumentModalTID.NameThisDocumentModalInput(),
            label: texts.documentNameLabel(),
            value: name,
            onChange: (e)=>{
                setName(e.target.value);
                setError(undefined);
            },
            inputProps: {
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' && !isSaving) {
                        handleSave();
                    }
                }
            },
            error: hasError,
            helperText: helperText,
            helperTextReserveSpace: true,
            width: "100%",
            autoFocus: true
        }),
        primaryButtonLabel: commonTexts.buttons.save(),
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        primaryButtonDisabled: hasError || !name.trim(),
        primaryButtonLoading: isSaving,
        onPrimaryButtonClick: handleSave,
        onSecondaryButtonClick: ()=>dismissModal()
    });
};
